import React from 'react';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { CIVILITES } from '../lib/personne';

export const CiviliteSelect = ({ value, onChange, label = 'Civilité', size = 'default', required = false, testId = 'select-civilite' }) => (
  <div className={size === 'sm' ? 'space-y-1' : 'space-y-2'}>
    <Label className={size === 'sm' ? 'text-[11px]' : undefined}>{label}{required ? ' *' : ''}</Label>
    <Select value={value || ''} onValueChange={onChange}>
      <SelectTrigger className={size === 'sm' ? 'h-9 text-sm' : undefined} data-testid={testId}>
        <SelectValue placeholder="—" />
      </SelectTrigger>
      <SelectContent>
        {CIVILITES.map((c) => (
          <SelectItem key={c.value} value={c.value} data-testid={`${testId}-${c.value === 'M.' ? 'm' : 'mme'}`}>{c.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
